import { Divider, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { useContext } from 'react';
import style from "../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss";
import contactStyle from '../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss'
import { campaignContact, campaignContactAssignmentData, campaignContactData, campaignContactFilter, getCampaignContactListResponse } from '../../../models/axiosModel';
import dashboardStyles from './../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisDashboard.module.scss';
import { ContactContext, ContactContextPayload } from '../../../context/contactContext';
import { filteredContacts } from './campaignConstant';
import { WhatsappCampaignContext, WhatsappCampaignContextPayload } from '../../../context/whatsappCampaignContext';


interface ContactListTableProps {
    // selectedContacts: campaignContact[],
    contact_list_id: number,
    tagIds: number[],
    contact_filter: campaignContactAssignmentData[],
}
const RetargetedContactTable: React.FC<ContactListTableProps> = (props: ContactListTableProps) => {
    const { contact_list_id, tagIds, contact_filter } = props;
    const { campaignContactData } = useContext(ContactContext) as ContactContextPayload;
    const { campaignContactListData } = useContext(ContactContext) as ContactContextPayload;
    const { selectedWhatsAppCampaign } = useContext(WhatsappCampaignContext) as WhatsappCampaignContextPayload;

    const sortFields = (fields: campaignContactData[]) => {
        return fields.sort((a, b) => a.contact_field_id - b.contact_field_id);
    }

    const innerHeight = (window.innerHeight - 280);

    const getTableHeaders = (contact: campaignContact[]): campaignContact => {
        let count = 0;
        for(let i = 0; i < contact.length; ++i){
            count = Math.max(count, contact[i].contact_data.length);
        }
        return contact.find((con: campaignContact) => con?.contact_data?.length == count)!;
    }
    

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container direction={"column"} justifyContent={"center"}>
                        <Grid item textAlign={"center"}>
                            <Typography className={style.popupTitleTypography}>{`Retargeted Contact List (${campaignContactListData && campaignContactListData.length > 0 && campaignContactListData.find((list) => list.contact_list_id === contact_list_id)?.contact_list_name || ""})`}</Typography>
                        </Grid>

                        <Divider className={style.popupTitleDivider} />

                        <Grid item sx={{ width: "100%" }}>
                            <Grid container className={style.popupBodyContainer}>
                                {campaignContactData && campaignContactData[0].contact.length > 0 &&
                                    <TableContainer sx={{ borderRadius: "5px", border: "1px solid #E9E9E9", maxWidth: "100%", overflow: "auto", boxSizing: "border-box", maxHeight: `${innerHeight}px !important` }}>
                                        <Table stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    {sortFields(getTableHeaders(campaignContactData[0]?.contact)?.contact_data).map((contact, ind) => {
                                                        return (
                                                            <TableCell key={ind} className={dashboardStyles.tableBodyHeadingFontStyle}>{contact.contact_field_name}</TableCell>
                                                        );
                                                    })}
                                                    <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Tags</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {(campaignContactData && campaignContactData[0].contact.length > 0 && contact_filter?.length > 0) ?
                                                    contact_filter?.map((contact: campaignContactAssignmentData, ind: number) => {
                                                        const typedContactData =  campaignContactData[0]?.contact?.find((con) => con.contact_id == contact.contact_id);
                                                        return (
                                                            <TableRow className={dashboardStyles.cellRow} key={ind}>
                                                                {sortFields(getTableHeaders(campaignContactData[0]?.contact)?.contact_data).map((field, index) => {
                                                                    return (
                                                                        <TableCell key={index} className={dashboardStyles.tableBodySubHeadingFontStyle}>
                                                                            {typedContactData?.contact_data?.find((contact: campaignContactData) => contact.contact_field_id == field.contact_field_id)?.contact_data_value || "-"}
                                                                        </TableCell>
                                                                    );
                                                                })}
                                                                <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>
                                                                    <Grid item>
                                                                        <Grid container gap={1} flexWrap={"nowrap"}>
                                                                            {(typedContactData && typedContactData?.contact_tag_assignment?.length > 0) ?
                                                                                typedContactData.contact_tag_assignment.map((tag, index) => {
                                                                                    return (
                                                                                        <Grid item key={ind+index} className={contactStyle.tagContainerGrid}>
                                                                                            <Typography className={contactStyle.tagNameTypography}>{tag.contact_tag_name}</Typography>
                                                                                        </Grid>
                                                                                    );
                                                                                })
                                                                                :
                                                                                "-"
                                                                            }
                                                                        </Grid>
                                                                    </Grid>
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })
                                                    :
                                                    <TableRow className={dashboardStyles.cellRow}>
                                                        <TableCell colSpan={12} sx={{ textAlign: "center" }}>
                                                            No Data Available
                                                        </TableCell>
                                                    </TableRow>
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default RetargetedContactTable
